<template>
  <div id="app">
    <div class="card container mx-auto" id="App">
      <ul class="card__ls">
        <Card
          v-for="item, index in res"
          :key="index"
          :item="item"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import Card from './components/Card';

export default {
  name: 'App',
  components: {
    Card,
  },
  data() {
    return {
      res: [
        {
          cate: '各項成就勳章',
          src: 'https://www.incode.tw/wp-content/uploads/2015/12/ingress_guardian-200x150.jpg',
          url: 'https://www.incode.tw/ingress-%e5%8b%b3%e7%ab%a0%e7%af%87-guardian.html',
        },
        {
          cate: '基本操作',
          src: 'https://www.incode.tw/wp-content/uploads/2015/08/ingress_xmp-200x150.jpg',
          url: 'https://www.incode.tw/ingress-weapon-xmp-burster.html',
        },
        {
          cate: 'Ingress',
          src: 'https://www.incode.tw/wp-content/uploads/2015/08/ingress_intro-200x150.jpg',
          url: 'https://www.incode.tw/%e4%bd%a0%e4%bb%8a%e5%a4%a9-ingress-%e4%ba%86%e5%97%8e%ef%bc%9f%e4%b8%80%e4%b8%8d%e5%b0%8f%e5%bf%83%e5%b0%b1%e7%bd%ae%e8%ba%ab%e9%9d%9e%e4%bd%a0%e6%89%80%e6%83%b3%e5%83%8f%e7%9a%84%e4%b8%96%e7%95%8c.html',
        },
        {
          cate: 'HTML',
          src: 'https://www.incode.tw/wp-content/uploads/2013/01/html5-200x150.jpg',
          url: 'https://www.incode.tw/%e6%b7%ba%e8%ab%87-html5.html',
        },
        {
          cate: 'Dreamweaver',
          src: 'https://www.incode.tw/wp-content/uploads/2012/12/spry-menu-200x150.jpg',
          url: 'https://www.incode.tw/dreamweaver-spry-%e9%81%b8%e5%96%ae%e5%88%97.html',
        },
      ],
    };
  },
}
</script>

<style>
*, *::before, *::after {
  box-sizing: border-box;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.container {
  width: 1200px;
}

.img-resp {
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
}

.text-right {
  text-align: right;
}

body {
  background-color: #ddd;
  font-size: 15px;
  font-family: Arial, Helvetica, "LiHei Pro", "Microsoft JhengHei", MingLiU, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue